const socketKeys = {
  SOCKET_ACTIVITY_FEED: 'socket-activity-feed',
  SOCKET_ONLINE_STUDENT: 'socket-online-student',
  SOCKET_STUDENT_JOIN_ROOM: 'socket-student-join-room',
  SOCKET_CLASS_BY_ID_CHANNEL: 'socket-class-by-id-channel',
  SOCKET_STUDENT_UPDATE_ANSWER: 'socket-student-update-answer',
  SOCKET_STUDENT_UPDATE_STATUS: 'socket-student-update-status',
  SOCKET_STUDENT_UPDATE_POSITION_QUESTION:
    'socket-student-update-position-question',
  SOCKET_STUDENT_SUBMIT: 'socket-student-submit-test',
  SOCKET_TEACHER_REQUEST_ONLINE_NUMBER: 'socket-teacher-request-online-number',
  SOCKET_TEACHER_PAUSE_RESUME: 'socket-teacher-pause-resume',
  SOCKET_TEACHER_CLEAR_ANSWER: 'socket-teacher-clear-answer',
  SOCKET_TEACHER_FORCE_SUBMIT: 'socket-teacher-force-submit',
  SOCKET_TEACHER_NEW_ATTEMPT: 'socket-teacher-new-attempt',
  SOCKET_TEACHER_KICK_STUDENT: 'socket-teacher-kick-student',
  SOCKET_TEACHER_KICK_STUDENT_MERGE_OR_TRANSFER:
    'socket-kick-student-merge-or-transfer',
  SOCKET_TEACHER_ENABLE_TEST: 'socket-teacher-enable-test',
  SOCKET_DISCONNECT_EVENT: 'socket-disconnect-student',
  SOCKET_STUDENT_LEAVE_ROOM: 'socket-student-leave-room',
  SOCKET_TEACHER_UNSUBSCRIBE_EVENT: 'socket-teacher-unsubscribe-event',
  SOCKET_ACTIVITY_FEED_COUNT: 'socket-activity-feed-count',
  SOCKET_STUDENT_TEST_TIME: 'socket-student-test-time',
  SOCKET_STUDENT_LOG_OUT: 'socket-student-log-out',
  SOCKET_TEACHER_VIEW_UPDATE: 'socket-teacher-view-update',
  SOCKET_STUDENT_DASHBOARD_EVENTS: 'socket-student-dashboard-events'
}

export default socketKeys
